import * as S from "./styles";
import Load from "/assets/imgs/escudo.svg";

export function Loading() {
  return (
    // Tira o foco do input do form por trás para que Enter não reenvie a requisição.
    <S.Wrapper tabIndex={-1} ref={(el: HTMLDivElement | null) => el?.focus()}>
      <S.WrapperImgs>
        {/* <S.ImgLogo src={"/assets/imgs/escudo.svg"} alt="logo" /> */}
        <S.ImgLoad src={"/assets/svgs/load.svg"} alt="Loagin" />
      </S.WrapperImgs>
      <span>Carregando...</span>
    </S.Wrapper>
  );
}
